import { Message } from '../types'
import { createReducer, createAction, PayloadAction } from '@reduxjs/toolkit'
import { RESET_CONNECTION_STATE } from './tutorChannelReducer'

export interface ChatMessagesReducer {
  messages: Message[]
  user: 'student' | 'tutor' | null
}

const initialState: ChatMessagesReducer = {
  messages: [],
  user: null
}

type HandleChatWsMessagePayload = Record<string, any>
export type HandleChatWsMessageActionType = PayloadAction<HandleChatWsMessagePayload>
export const HANDLE_CHAT_WS_MESSAGE = createAction<HandleChatWsMessagePayload>(
  'chat_messages_reducer/handle_chat_ws_message'
)

export const ADD_CHAT_MESSAGE = createAction<Message>('chat_messages_reducer/add_chat_message')

export const TRANSLATE_CHAT_MESSAGE = createAction<{ id: number; message: string }>(
  'chat_messages_reducer/translate_chat_message'
)

export const SET_CHAT_USER = createAction<{ user: 'student' | 'tutor' }>('chat_messages_reducer/set_chat_user')

export const CLEAR_CHAT_MESSAGE = createAction<{ id: number }>('chat_messages_reducer/clear_chat_message')

export const chatMessagesReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(ADD_CHAT_MESSAGE, (state, action) => {
      return { ...state, messages: [...state.messages, action.payload] }
    })
    .addCase(TRANSLATE_CHAT_MESSAGE, (state, action) => {
      return {
        ...state,
        messages: state.messages.map((message) =>
          message.id === action.payload.id
            ? { ...message, message: action.payload.message, translated: true, originalMessage: message.message }
            : message
        )
      }
    })
    .addCase(CLEAR_CHAT_MESSAGE, (state, action) => {
      return {
        ...state,
        messages: state.messages.map((message) =>
          message.id === action.payload.id
            ? { ...message, message: message.originalMessage ?? '', translated: false }
            : message
        )
      }
    })
    .addCase(SET_CHAT_USER, (state, action) => {
      return { ...state, user: action.payload.user }
    })
    .addCase(RESET_CONNECTION_STATE, (state) => {
      return { ...state, messages: [] }
    })
})
